import React from 'react';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import {
  getContainerStyles,
  FULL_CONTAINER_RATIO,
  HORIZONTAL_RATIO,
} from 'Components/widgets/inspirational-grid/InspirationalGrid';
import { InspirationalPicture } from 'Components/widgets/inspirational-grid/InspirationalPicture';
export const InspirationalGridFull = ({ pictures }: InspirationalGridProps) => {
  const containerStyles = getContainerStyles(FULL_CONTAINER_RATIO);
  return (
    <div className="relative h-0 w-full" style={containerStyles}>
      <div className="absolute inset-0 flex overflow-hidden">
        <div className="relative left-1/2 inline-flex shrink-0 -translate-x-1/2 transform">
          <div className="w-[calc(580/1440*100vw)]">
            <InspirationalPicture
              className="h-full"
              descriptionStyle={{
                paddingLeft: 'calc(190 / 1440 * 100vw)',
              }}
              ratioDisplay={1 / 2}
              ratioKey={HORIZONTAL_RATIO}
              {...pictures[0]}
              index={1}
              radius={10}
            />
          </div>
          <div className="mx-[calc(40/1440*100vw)] my-0 w-[calc(580/1440*100vw)]">
            <InspirationalPicture
              className="h-full"
              ratioDisplay={1 / 2}
              ratioKey={HORIZONTAL_RATIO}
              {...pictures[1]}
              index={2}
              radius={10}
            />
          </div>
          <div className="w-[calc(580/1440*100vw)]">
            <InspirationalPicture
              className="h-full"
              descriptionStyle={{
                paddingRight: 'calc(190 / 1440 * 100vw)',
              }}
              ratioDisplay={1 / 2}
              ratioKey={HORIZONTAL_RATIO}
              {...pictures[2]}
              index={3}
              radius={10}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
